<div class="containerForm">
  <iframe
    *ngIf="idioma == 'es'"
    src="https://firebasestorage.googleapis.com/v0/b/colegia-education-demo.firebasestorage.app/o/Manuales%2FManual_Alumno_Colegia(ESP).pdf?alt=media&token=c87fc1aa-db90-4ab9-acff-955836a6da26"
    name="iframe1"
    id="iframe1"
    width="100%"
    height="100%"
  ></iframe>
  <iframe
    *ngIf="idioma != 'es'"
    src="https://firebasestorage.googleapis.com/v0/b/colegia-education-demo.firebasestorage.app/o/Manuales%2FManual_Alumno_Colegia(ESP).pdf?alt=media&token=c87fc1aa-db90-4ab9-acff-955836a6da26"
    name="iframe1"
    id="iframe1"
    width="100%"
    height="100%"
  ></iframe>
</div>
